import styled from "styled-components"


export const Container = styled.li `
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    background-color: #313131;
    margin: 10px 0px;
`

export const BoxInfo = styled.div `
    width: 400px;
    height: 256px;
    box-shadow: 1px 1px 20px black;
    padding: 10px;
    display: flex;
    flex-direction: row;

    @media (max-width: 400px){
        width: 300px;
    }
`

export const LeftSide = styled.div `
    width: 100%;
    height: 100%;
`

export const RightSide = styled.div `
    p {
        font-size: 1.2rem;
        font-style: italic;
        word-break: break-word;
    }

    .beerName {
        p {
            color: orange;
            padding-bottom: 10px;
        }
    }

    .beerDescription {
        p {
            word-break: break-word;
            overflow: auto;
            height: 160px;

            ::-webkit-scrollbar {
                width: 8px;
            }
            
            ::-webkit-scrollbar-track {
                border-radius: 8px;
                background-color: transparent;
            }
            
            ::-webkit-scrollbar-thumb {
                border-radius: 8px;
                background-color: gray;
            }
        }
    }
`

export const BeerImage = styled.div `
    img {
        width: 150px;
        height: 200px;
        background-repeat: no-repeat;
        object-fit: contain;
    }
`

export const Options = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #313131;
    padding: 10px 0px;
    border-top: 2px solid #131313;

    button {
        background: linear-gradient(to right, green, #3BFF5F);
        color: black;
        text-shadow: 1px 1px 5px black;
        padding: 10px;
        margin: 0px 10px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 1rem;
        box-shadow: 1px 1px 20px black;

        @media (max-width: 400px){
            margin-top: 10px;
        }
    }
`